import { render, staticRenderFns } from "./ProductGroupManagementCodePopupIframe.vue?vue&type=template&id=9665bb02&"
import script from "./ProductGroupManagementCodePopupIframe.vue?vue&type=script&lang=ts&"
export * from "./ProductGroupManagementCodePopupIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports